const convertImageToBlob = async (image) => {
  const scale = 0.5;
  const imageQualtity = 0.6;

  const canvas = document.createElement('canvas');
  canvas.width = image?.videoWidth * scale;
  canvas.height = image?.videoHeight * scale;

  const ctx = canvas.getContext('2d');
  ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

  const blob = await new Promise((resolve) => {
    canvas.toBlob((b) => resolve(b), 'image/jpg', imageQualtity);
  });

  return blob;
};

export default convertImageToBlob;
